module.exports = __webpack_public_path__ + "img/ceramic-yellow.99690cb0.webp";